import roleAccessConfig from './role-access.json';

// Users without a role are unrestricted; a role missing from the config is denied.
export const isServiceRequestAllowed = (role, requestType, accessList) => {
  if (!role) return true;
  const roleConfig = roleAccessConfig[role];
  if (!roleConfig) return false;
  if (roleConfig.serviceRequests.includes(requestType)) return true;
  const requiredAccess = roleConfig.gatedServiceRequests?.[requestType];
  return Boolean(requiredAccess) && accessList?.[requiredAccess] === true;
};
